import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { BookmarkedJobPostsQueryMetadata } from './types';

import { paginatedApiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostSchema } from './schemas';

const bookmarkedJobPostsQueryOptions = (metadata: BookmarkedJobPostsQueryMetadata) =>
  queryOptions({
    queryKey: QueryKeys.jobPosts.index.bookmarked.metadata(metadata),
    queryFn: async () => {
      const { pagination } = metadata;

      const response = await fetchJson('/job-posts', {
        schema: paginatedApiResourceSchema(jobPostSchema.array()),
        params: {
          pagination: { pageIndex: pagination.pageIndex + 1, pageSize: pagination.pageSize },
          bookmarked: true,
        },
      });

      return response;
    },
    staleTime: 30 * 1000,
    gcTime: 2 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

export const useBookmarkedJobPosts = (metadata: BookmarkedJobPostsQueryMetadata) => {
  return useQuery(bookmarkedJobPostsQueryOptions(metadata));
};
